const count = 9
const token = '3688536766.d35a26c.fa70bcde6a7844659d2df6d6737c4ce6'
const api = `https://api.instagram.com/v1/users/self/media/recent/?access_token=${token}&count=${count}`

export default api
